import { createSelector } from "reselect";

/**
 * selector to determine if patient overview cormorbidities is enabled
 */
export const patientOverviewCormorbiditiesEnabledSelector = createSelector(
  () => false
);
